import React from "react";
import styles from "./CustomerPaintPoint.module.scss";
import Image from "next/image";
function CustomerPainPoint() {
  return (
    <div className={styles["customer-point-wrapper"]}>
      <div className={styles["customer-point-image"]}>
        <Image
          src={"/reviewrating/review-semantic-analysis.png"}
          alt=""
          width={500}
          height={400}
          className={styles["paint-image"]}
        ></Image>
      </div>
      <div className={styles["customer-point-content"]}>
        <h1>Maximize Insights with the Customer Reviews & Ratings Dashboard</h1>
        <p>
          Socommerz&apos;s price Engine review models offers features like
          review velocity analysis to assists in boosting your positive review
          count, directly impacting your digital reputation.
        </p>
      </div>
    </div>
  );
}

export default CustomerPainPoint;
